<template>
  <vs-chip v-if="status" :color="statusModifier.color || ''">{{
    statusModifier.text
  }}</vs-chip>
</template>

<script>
import {
  STATUS_UNREAD,
  STATUS_READ,
  STATUS_ARCHIVE
} from "@/const/whistleblower";

export default {
  props: {
    status: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      statusList: [
        {
          comparison: STATUS_UNREAD,
          color: "",
          text: "Belum Dibaca"
        },
        {
          comparison: STATUS_READ,
          color: "success",
          text: "Dibaca"
        },
        {
          comparison: STATUS_ARCHIVE,
          color: "primary",
          text: "Arsip"
        },
      ]
    };
  },
  computed: {
    statusModifier() {
      return this.statusList.find(({ comparison }) => {
        return comparison == this.status;
      });
    }
  }
};
</script>
